
export default function CTA() {
  return (
    <section id="contact" className="py-24 px-6 lg:px-12 bg-gradient-to-br from-[#7C3AED] to-[#A855F7]">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl lg:text-5xl font-bold text-white leading-tight mb-6">
          Ready to Grow Your Healthcare Practice?
        </h2>
        <p className="text-lg text-white/90 leading-relaxed mb-8">
          Book a free strategy call to discover how our HIPAA-compliant marketing automation can help you attract more qualified patients and scale your practice ethically.
        </p>

        <div className="flex flex-wrap gap-4 justify-center mb-12">
          <a
            href="#book-call"
            className="bg-white text-[#7C3AED] px-8 py-4 rounded-lg hover:bg-gray-50 transition-all hover:shadow-xl cursor-pointer whitespace-nowrap font-bold inline-flex items-center gap-2"
          >
            <span>Book Your Strategy Call</span>
            <i className="ri-calendar-line"></i>
          </a>
          <a
            href="#demo"
            className="border-2 border-white text-white px-8 py-4 rounded-lg hover:bg-white hover:text-[#7C3AED] transition-all cursor-pointer whitespace-nowrap font-bold"
          >
            Request Platform Demo
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-8 text-white/80 text-sm">
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-white"></i>
            <span>No Long-Term Contracts</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-white"></i>
            <span>HIPAA-Compliant Systems</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-white"></i>
            <span>Dedicated Healthcare Team</span>
          </div>
        </div>
      </div>
    </section>
  );
}
